import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'safeSpecialCharFilter',
})
export class SafeSpecialCharFilterPipe implements PipeTransform {
  transform(input: string, valueType: string): string {
    if (_.isUndefined(input) || _.isNull(input)) {
      return input;
    }

    const charMaps = [
      { placeholder: '#SingleQuote#', character: "'" },
      { placeholder: '#DoubleQuote#', character: '"' },
      { placeholder: '#Hyphen#', character: '-' },
      { placeholder: '#Colon#', character: ':' },
      { placeholder: '#Comma#', character: ',' },
    ];

    switch (valueType) {
      case 'escape':
        _.forEach(charMaps, function (charMap) {
          input = input.replace(new RegExp(charMap.character, 'g'), charMap.placeholder);
        });
        return input;
      case 'unescape':
        _.forEach(charMaps, function (charMap) {
          input = input.replace(new RegExp(charMap.placeholder, 'g'), charMap.character);
        });
        return input;
      default:
        return input;
    }
  }
}
